import React from 'react'
import { styled } from '@mui/material/styles'
import {
  Accordion as AccordionMui,
  AccordionSummary,
  AccordionDetails,
  AccordionActions,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import PropTypes from 'prop-types'

const PREFIX = 'Accordion'

const classes = {
  root: `${PREFIX}-root`,
  disabled: `${PREFIX}-disabled`,
}

const StyledAccordionMui = styled(AccordionMui)(() => {
  return {
    [`& .${classes.root}`]: {
      fontSize: 16,
      fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'],
      color: '#333333',
      '&$disabled': {
        backgroundColor: 'white',
        color: '#888888',
      },
    },
    [`& .${classes.disabled}`]: {},
  }
})

const Accordion = props => {
  const { title, summary, actions } = props

  return (
    <StyledAccordionMui
      classes={{
        root: classes.root,
        disabled: classes.disabled,
      }}
      {...props}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {title}
      </AccordionSummary>
      {summary ? <AccordionDetails>{summary}</AccordionDetails> : null}
      {actions ? <AccordionActions>{actions}</AccordionActions> : null}
    </StyledAccordionMui>
  )
}

Accordion.propTypes = {
  classes: PropTypes.object,
  title: PropTypes.object.isRequired,
  summary: PropTypes.object,
  onChange: PropTypes.func,
  actions: PropTypes.object,
  defaultExpanded: PropTypes.bool,
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default Accordion
